import { HeadData } from '@/components/HeadData';
import { graphql } from '@/gql/codegen/gql';
import { useSuspenseQuery } from '@apollo/client';
import { createFileRoute } from '@tanstack/react-router';
import { SkillCheckTestResultContainer } from './-container';

export const GET_USER_SKILL_CHECK_TEST_RESULT = graphql(/* GraphQL */ `
  query EmbaUserSkillCheckTestResult($embaUserAttendanceSlug: String!) {
    embaUserSkillCheckTestResult(
      embaUserAttendanceSlug: $embaUserAttendanceSlug
    ) {
      ...EmbaUserSkillCheckTestResultContainer
      embaCourseSkillCheckTest{
        embaCourse{
          name
        }
      }
    }
  }
`);

type SkillCheckTestResultSearch = {
  timeUp: boolean;
  isAnswered?: boolean;
};

export const Route = createFileRoute(
  '/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout/skill-check-test/result/',
)({
  component: component,
  validateSearch: (
    search: Record<string, unknown>,
  ): SkillCheckTestResultSearch => {
    // validate and parse the search params into a typed state
    return {
      timeUp: search.timeUp as boolean,
      isAnswered: search.isAnswered as boolean,
    };
  },
});

function component() {
  const { userAttendanceSlug } = Route.useParams();

  const { error, data } = useSuspenseQuery(GET_USER_SKILL_CHECK_TEST_RESULT, {
    variables: {
      embaUserAttendanceSlug: userAttendanceSlug,
    },
  });

  if (error) {
    throw error;
  }

  const { timeUp, isAnswered } = Route.useSearch();

  return (
    <>
      <HeadData
        title={
          data.embaUserSkillCheckTestResult.embaCourseSkillCheckTest.embaCourse
            .name
        }
      />
      <SkillCheckTestResultContainer
        embaUserSkillCheckTestResult={data.embaUserSkillCheckTestResult}
        userAttendanceSlug={userAttendanceSlug}
        timeUp={timeUp}
        isAnswered={isAnswered}
      />
    </>
  );
}
